import React, { useState } from 'react';
import moment from 'moment';

import useGlobal from '../../../../store';
import SearchInput from '../../../../facturotopia/search-input/SearchInput';
import CalendarDateRangePicker from '../../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker.jsx';

const mapState = (store) => {
  return {
    socios: store.modulo.socios.list,
  };
};

const mapActions = (actions) => {
  return { ...actions.modulo.socios.list };
};

const SociosDeNegocioSearch = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const from = moment().subtract(1, 'month').toDate();
  const to = moment().toDate();

  const [date, setDate] = useState([from, to]);

  const { filters } = state.socios;

  const handleOnKeywordChange = (keyword) => {
    actions.paginate({
      ...filters,
      search: keyword,
    });
  };

  const handleOnSearchClear = () => {
    handleOnKeywordChange('');
  };

  const handleOnDateChange = (date) => {
    const from = moment(date[0]);
    const to = moment(date[1]);

    setDate(date);

    actions.paginate({
      ...filters,
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD'),
    });
  };

  const { search } = filters;

  return (
    <div className="d-flex flex-column flex-sm-row">
      <div className="d-flex flex-column flex-sm-row">
        <div className="pr-2 pb-2">
          <CalendarDateRangePicker
            value={date}
            onDateChange={handleOnDateChange}
          />
        </div>
        <div className="flex-fill search-container">
          <SearchInput
            onKeywordChange={handleOnKeywordChange}
            onClear={handleOnSearchClear}
            value={search}
          />
        </div>
      </div>
    </div>
  );
};

export default SociosDeNegocioSearch;
